import React from 'react';
import './style.css';
import { Col, Row, ProgressBar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import CartTotal from '../cart-total';

const ProgressBarCheckout = (props) => {
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  let firstPageText = props.firstPage;
  if (props.useAlt) firstPageText = props.firstPageAlt;
  if (props.useAltTwo) firstPageText = props.firstPageAltTwo;

  const firstPageTitle = capitalizeFirstLetter(firstPageText);
  const secondPageTitle = capitalizeFirstLetter(props.secondPage);
  const thirdPageTitle = capitalizeFirstLetter(props.thirdPage);

  function renderSecondButton() {
    return props.hasSecondPageBeenSuccessfullyCompleted ? (
      <Row>
        <Col xs={3}>
          <FontAwesomeIcon icon={faCheck} className='checkIcon' />
        </Col>
        <Col xs={8} className='progressBarBtnColSecond'>
          <button
            className='progressBarButton'
            type='button'
            aria-label='Go to Step 2'
            onClick={() => props.setRenderPage(props.secondPage, 50)}
            disabled={!props.isFirstPageReady() && !props.isSecondPageReady()}
          >
            <h6>{secondPageTitle}</h6>
          </button>
        </Col>
      </Row>
    ) : (
      <Row className='progressBarCustomizeRow'>
        <Col xs={12}>
          <button
            className='progressBarButton'
            type='button'
            aria-label='Go to Step 2'
            onClick={() => props.setRenderPage(props.secondPage, 50)}
            disabled={!props.isFirstPageReady() && !props.isSecondPageReady()}
          >
            <h6>2. {secondPageTitle}</h6>
          </button>
        </Col>
      </Row>
    );
  }

  function renderPageContent() {
    return (
      <div className='progressBarCheckout'>
        {props.showCartTotal ? (
          <CartTotal
            title='Checkout'
            totalCost={props.totalCost.toFixed(2)}
            subTotal={props.subTotal.toFixed(2)}
            tax={props.taxesAndFees.toFixed(2)}
            totalDiscount={props.totalDiscount.toFixed(2)}
            shippingInsuranceCost={props.shippingInsuranceCost.toFixed(2)}
            cartInfo={props.cartInfo}
            isInfinityPlan={props.isInfinityPlan}
            shipping={props.shipping}
          />
        ) : null}

        <Row className='progressBarRow'>
          <Col xs={4} sm={4} md={4} lg={4}>
            {props.isProgressButtonActive(props.firstPage) ? (
              <Row className='progressBarFirstPageRow'>
                <Col xs={2} sm={2} className='checkMarkCol'>
                  <FontAwesomeIcon icon={faCheck} className='checkIcon' />
                </Col>
                <Col xs={8} className='progressBarBtnCol progressBarFirstPage1'>
                  <button
                    className='progressBarButton'
                    type='button'
                    aria-label='Go to Step 1'
                    onClick={() => props.setRenderPage(props.firstPage, 25)}
                    disabled={!props.isFirstPageReady()}
                  >
                    <h6>{firstPageTitle}</h6>
                  </button>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col xs={10} className='progressBarBtnCol progressBarShipping2'>
                  <h6 className='progressBarButton'>1. {firstPageTitle}</h6>
                </Col>
              </Row>
            )}
          </Col>
          <Col xs={4} sm={4} md={4} lg={4}>
            {props.isProgressButtonActive(props.secondPage) ? (
              renderSecondButton()
            ) : (
              <Row>
                <Col xs={12} className='progressBarBtnColSecondPage'>
                  <h6 className='progressBarButton'>2. {secondPageTitle}</h6>
                </Col>
              </Row>
            )}
          </Col>
          <Col xs={4} sm={4} md={4} lg={4}>
            {props.isProgressButtonActive(props.secondPage) ||
            props.isProgressButtonActive(props.thirdPage) ? (
              <Row className='progressBarThirdPageRow1'>
                <Col xs={8} className='progressBarBtnCol progressThirdPageCol1'>
                  <button
                    className='progressBarButton'
                    type='button'
                    aria-label='Go to Step 3'
                    onClick={() => props.setRenderPage(props.thirdPage, 75)}
                    disabled={!props.hasSecondPageBeenSuccessfullyCompleted}
                  >
                    <h6>3. {thirdPageTitle}</h6>
                  </button>
                </Col>
              </Row>
            ) : (
              <Row className='progressBarThirdPAgeRow2'>
                <Col
                  xs={10}
                  className='progressBarBtnCol progressThirdPageCol2'
                >
                  <h6 className='progressBarButton'>3. {thirdPageTitle}</h6>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
        <Row>
          <ProgressBar
            now={props.progressBar}
            style={{ backgroundImage: 'pink' }}
          />
        </Row>
        {props.showShippingInsurance ? props.shippingInsurance : null}
        {props.showCheckoutAddressBrownBox
          ? props.checkoutAddressBrownBox
          : null}
        <div className='progressBarContainer' id={props.id}>
          {props.renderCurrentPage()}
          {props.pageDisplayed === props.secondPage ? (
            <Row className='previousStepRow'>
              <Col
                xs={10}
                sm={10}
                md={10}
                lg={10}
                className='previousStepRowCol'
              >
                <button
                  onClick={() => props.setRenderPage(props.firstPage, 25)}
                  className='returnBtn'
                  type='button'
                  aria-label='Go to Previous Step - Step 1'
                >
                  {'<'} RETURN TO PREVIOUS STEP
                </button>
              </Col>
            </Row>
          ) : null}
          {props.pageDisplayed === props.thirdPage ? (
            <Row className='previousStepRow'>
              <Col
                xs={10}
                sm={10}
                md={10}
                lg={10}
                className='previousStepRowCol'
              >
                <button
                  onClick={() => props.setRenderPage(props.secondPage, 50)}
                  className='returnBtn'
                  type='button'
                  aria-label='Go to Previous Step - Step 2'
                >
                  {'<'} RETURN TO PREVIOUS STEP
                </button>
              </Col>
            </Row>
          ) : null}
        </div>
      </div>
    );
  }

  return renderPageContent();
};

export default ProgressBarCheckout;
